import { Skeleton, Text } from '@costar-ui/components';
import React from 'react';

var JobTitle = function JobTitle(props) {
  var label = props.label,
    testId = props.testId,
    isLoading = props.isLoading;
  return isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25",
    className: "csg-tw-skeleton-job-title"
  }) : label && /*#__PURE__*/React.createElement(Text, {
    variant: "text-16",
    "automation-id": "job-title",
    className: "wrap-anywhere",
    testId: testId
  }, label);
};

export { JobTitle };
//# sourceMappingURL=job-title.esm.js.map
